import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Bring the price down!... `}</p>
    <h1>{`TLDR`}</h1>
    <ol>
      <li parentName="ol">{`Amazingly cheap model and historical low price at 1m token for just a few cents?! That's insane.`}</li>
      <li parentName="ol">{`Full open source model that you can host at home if you have like 400GB machine(M3 Ultra 512GB?)...`}</li>
      <li parentName="ol">{`Distilled model on ollama is crap and I feel it's even worse than llama3 or phi4 with my own translation tasks.`}</li>
      <li parentName="ol">{`The hype seems to be on true open source model (what openai should have done year ago). Hope one day it'll come out with smaller size but as smart as big one.`}</li>
      <li parentName="ol">{`The model is unfortunately censored 🚨.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      